import { useForm, Link } from '@inertiajs/react'
import type { FormEvent } from 'react'
import { GuestLayout } from '@/components/layout/GuestLayout'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { new_user_registration_path, user_session_path } from '@/lib/routes'

interface LoginProps {
  errors?: {
    email?: string[]
  }
  flash?: {
    alert?: string
    notice?: string
  }
}

export default function Login({ errors, flash }: LoginProps) {
  const { data, setData, post, processing } = useForm({
    user: {
      email: '',
      password: '',
      remember_me: true, // 長期ログイン維持のため常に有効
    },
  })

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault()
    post(user_session_path())
  }

  return (
    <GuestLayout>
      {flash?.alert && (
        <div className="mb-4 rounded-md border border-yellow-200 bg-yellow-50 p-3 text-sm text-yellow-800">
          {flash.alert}
        </div>
      )}
      <form onSubmit={handleSubmit} className="space-y-6">
        <div>
          <Label htmlFor="email">メールアドレス</Label>
          <div className="mt-1">
            <Input
              id="email"
              name="email"
              type="email"
              autoComplete="email"
              required
              value={data.user.email}
              onChange={(e) =>
                setData('user', { ...data.user, email: e.target.value })
              }
            />
          </div>
          {errors?.email && (
            <p className="text-destructive mt-2 text-sm">{errors.email[0]}</p>
          )}
        </div>

        <div>
          <Label htmlFor="password">パスワード</Label>
          <div className="mt-1">
            <Input
              id="password"
              name="password"
              type="password"
              autoComplete="current-password"
              required
              value={data.user.password}
              onChange={(e) =>
                setData('user', { ...data.user, password: e.target.value })
              }
            />
          </div>
        </div>

        <div>
          <Button type="submit" className="w-full" disabled={processing}>
            ログイン
          </Button>
        </div>

        <div className="text-center text-sm">
          <span className="text-muted-foreground">
            アカウントをお持ちでない方は{' '}
          </span>
          <Link
            href={new_user_registration_path()}
            className="text-primary font-medium hover:underline"
          >
            新規登録
          </Link>
        </div>
      </form>
    </GuestLayout>
  )
}
